// Import core lib dependencies.
import { createSelector } from 'reselect';

// Config.
import Config from './config/config.js';

/**
 * <pre>
 * Voting module Selectors(s).
 *
 * Summary of responsibilities:
 *
 *  - defines reusable selectors to retrieve state properties
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Voting
 * @namespace
 *
 * @type {Object}
 */
const Selectors = {};

/**
 * Selector to access votes property of Redux state for this module.
 *
 * @memberof module:Voting.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @param  {Integer} id     The item id.
 * @return {Object}  The value of the retrieved state property.
 */
const votesSelector = (state, id) => state[Config.stateKey].votes[id];
Selectors.getVotes = createSelector([votesSelector], stateVal => {
  return stateVal;
});

/**
 * Selector to access isVoting property of Redux state for this module.
 *
 * @memberof module:Voting.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @return {Object}  The value of the retrieved state property.
 */
const isVotingSelector = state => state[Config.stateKey].isVoting;
Selectors.getIsVoting = createSelector([isVotingSelector], stateVal => {
  return stateVal;
});

/**
 * Selector to access showDynRecaptcha property of Redux state for this module.
 *
 * @memberof module:Voting.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @return {Object}  The value of the retrieved state property.
 */
const showDynRecaptchaSelector = state => state[Config.stateKey].showDynRecaptcha;
Selectors.getShowDynRecaptcha = createSelector([showDynRecaptchaSelector], stateVal => {
  return stateVal;
});

/**
 * Selector to access showPostVoteCTA property of Redux state for this module.
 *
 * @memberof module:Voting.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @return {Object}  The value of the retrieved state property.
 */
const showPostVoteCTASelector = state => state[Config.stateKey].showPostVoteCTA;
Selectors.getShowPostVoteCTA = createSelector([showPostVoteCTASelector], stateVal => {
  return stateVal;
});

/**
 * Selector to access postVoteCTAContent property of Redux state for this module.
 *
 * @memberof module:Voting.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @return {Object}  The value of the retrieved state property.
 */
const postVoteCTAContentSelector = state => state[Config.stateKey].postVoteCTAContent;
Selectors.getPostVoteCTAContent = createSelector([postVoteCTAContentSelector], stateVal => {
  return stateVal;
});

/**
 * Selector to access message property of Redux state for this module.
 *
 * @memberof module:Voting.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @return {Object}  The value of the retrieved state property.
 */
const messageSelector = state => state[Config.stateKey].message;
Selectors.getMessage = createSelector([messageSelector], stateVal => {
  return stateVal;
});

export default Selectors;
